export default __webpack_public_path__ + "static/media/YAS0340.34I-29792_-17235_0.78270fa1.jpg";